import { createReducer } from '@reduxjs/toolkit';

import { BalanceStateType } from '../../types';
import { fetchBalanceInfo, setBalanceLoading } from '../actions/balance';

const initialState: BalanceStateType = {
  data: {
    info: {
      hybridCount: 0,
      hybridValue: 0,
      simpleTokenValue: 0,
      creditSimpleTokenValue: 0,
      holdTokenValue: 0,
      simpleTokens: {},
    },
  },
  loading: {
    info: false,
  },
};

const balanceReducer = createReducer(initialState, (builder) => {
  builder.addCase(setBalanceLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });

  builder.addCase(fetchBalanceInfo.fulfilled, (state, action) => {
    state.data.info = action.payload;
  });
});

export default balanceReducer;
